module.exports = __webpack_public_path__ + "img/s3.b5093c7b.png";